function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null);

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "icons8-typescript",
  d: "M3,12.995V82.957a9.992,9.992,0,0,0,9.995,9.995H82.957a9.992,9.992,0,0,0,9.995-9.995V12.995A9.992,9.992,0,0,0,82.957,3H12.995A9.992,9.992,0,0,0,3,12.995ZM56.3,50.23H45.717V82.957h-8.53V50.23H26.822V42.979H56.3Zm1.659,30.859v-8.75a19.627,19.627,0,0,0,10.514,3.6c5.737,0,5.512-3.748,5.512-4.263,0-5.442-16.246-5.442-16.246-17.5,0-16.4,23.672-9.925,23.672-9.925l-.295,7.791A17.272,17.272,0,0,0,72.663,49.4c-4.483,0-6.1,2.134-6.1,4.413,0,5.882,16.4,5.292,16.4,17.131C82.957,89.174,57.961,81.088,57.961,81.088Z",
  transform: "translate(-3 -3)"
});

function SvgTypeScript(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89.952,
    height: 89.952,
    viewBox: "0 0 89.952 89.952",
    transform: "translate(0 3)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeScript);
export default __webpack_public_path__ + "static/media/TypeScript.a7377f97.svg";
export { ForwardRef as ReactComponent };